import Layout from "@/components/layout/index.vue";
//权限管理
export default [{
    path: "/",
    name: "managementLayout",
    component: Layout,
    meta: {
        title: "配置中心"
    },
    children: [{
            path: '/management/label',
            name: 'label',
            meta: {
                title: "标签管理"
            },
            component: () =>
                import ('@/views/management/label/label.vue'),
        },
        {
            path: '/management/imgtex',
            name: 'image',
            meta: {
                title: "客户阶段管理"
            },
            component: () =>
                import ('@/views/management/imagetex/imgtex.vue'),

        },
        {
            path: '/management/merchant',
            name: 'merchant',
            meta: {
                title: "商户服务配置"
            },
            component: () =>
                import ('@/views/management/merchant/merchant.vue'),
        }
    ]
}];